import React from 'react';
import * as Styled from '../styled/panel-guidance-styled';
import { BaSeHeading6, BaSeParagraph, BaSeTheme } from '@base/react';

const ICON_URL =
  'https://storage.googleapis.com/sebrae-hdqa-assets/comum/hdqa-logo-mini.png';

type TextSection = {
  type: 'text';
  content: string;
};

type DashListSection = {
  type: 'dash-list';
  subtitle?: string;
  items: string[];
};

type BulletListSection = {
  type: 'bullet-list';
  subtitle?: string;
  items: string[];
};

type InfoPanelSection = TextSection | DashListSection | BulletListSection;

interface InfoPanelFragmentProps {
  title: string;
  sections: InfoPanelSection[];
}

const {
  feedbackInterface: { azulSebrae10, azulSebrae36 },
} = BaSeTheme.colors;

const renderSection = (section: InfoPanelSection, index: number) => {
  switch (section.type) {
    case 'text':
      return (
        <Styled.SectionWrapper key={index}>
          <BaSeParagraph
            fontFamily="Campuni"
            color={azulSebrae10}
            withNewLineWrap={true}
          >
            {section.content}
          </BaSeParagraph>
        </Styled.SectionWrapper>
      );

    case 'dash-list':
    case 'bullet-list': {
      const listType = section.type === 'dash-list' ? 'dash' : 'bullet';
      return (
        <Styled.SectionWrapper key={index}>
          {section.subtitle && (
            <BaSeParagraph isBold fontFamily="Campuni" color={azulSebrae10}>
              {section.subtitle}
            </BaSeParagraph>
          )}
          <Styled.List listType={listType}>
            {section.items.length === 1
              ? section.items.map((item, itemIndex) => (
                  <BaSeParagraph
                    key={itemIndex}
                    fontFamily="Campuni"
                    color={azulSebrae10}
                  >
                    {item}
                  </BaSeParagraph>
                ))
              : section.items.map((item, itemIndex) => (
                  <Styled.ListItem key={itemIndex} listType={listType}>
                    <BaSeParagraph fontFamily="Campuni" color={azulSebrae10}>
                      {item}
                    </BaSeParagraph>
                  </Styled.ListItem>
                ))}
          </Styled.List>
        </Styled.SectionWrapper>
      );
    }

    default:
      return null;
  }
};

const PanelGuidanceFragment: React.FC<InfoPanelFragmentProps> = ({
  title,
  sections,
}) => {
  return (
    <Styled.Container>
      <Styled.TitleWrapper>
        <Styled.IconImage src={ICON_URL} alt="logo em miniatura do hdqa" />
        <BaSeHeading6 isBold fontFamily="Campuni" color={azulSebrae36}>
          {title}
        </BaSeHeading6>
      </Styled.TitleWrapper>

      {sections.map(renderSection)}
    </Styled.Container>
  );
};

export { PanelGuidanceFragment };
